import { useLanguageStore } from '../../app/store';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/features/auth/model/auth.store';
import { userApi } from '@entities/user';
import type { Language } from '@/app/store/languageStore';

export const useLanguage = () => {
  const { t, i18n } = useTranslation();
  const { language, setLanguage, availableLanguages } = useLanguageStore();
  const { user, setUser, isAuthenticated } = useAuthStore();

  const changeLanguage = (lang: Language) => {
    setLanguage(lang);
    if (isAuthenticated && user) {
      const updatedUser = { ...user, preferredLanguage: lang };
      setUser(updatedUser);
      userApi.updatePreferredLanguage(lang).catch(() => {
        // Persist to backend in background; ignore errors (e.g. network)
      });
    }
  };

  return {
    t,
    language,
    changeLanguage,
    availableLanguages,
    isRTL: i18n.dir() === 'rtl',
  };
};
